import { Avatar, Box, Container, Grid, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { Zoom } from '../../../../../core/global/Zoom';
import { KeyboardDoubleArrowRight } from '@mui/icons-material'

export const Preview = ({marketing_camp}) => {
    const { form, custom, job } = marketing_camp
    const inputs = form.data
    const history = useHistory()

    const handlerCustomDesign = (e, name) => {
        e.stopPropagation()
        custom.set(name)
        history.push('?id=3&step=design')
    }

    const highlightCustom = {
        ':hover': { borderBottom : '1px solid #00ACC1', cursor: 'pointer', bgcolor: 'rgba(0, 172, 193, 0.1)' },
        transition: 'all 0.2s ease-in-out'
    }

    const handlerChangeImage = (e) => {
        e.stopPropagation()
        history.push('?step=content')
        const { name, files } = e.target
        let val;
        const upld_file = files[0]
        val = {value: upld_file, object: URL.createObjectURL(upld_file), stat: false, msg: '', type: upld_file.type.split('/')[0]}
        form.set({...form.data, [name] : val})
    }

    const handlerBg = () => {
        history.push(`?id=3&step=design`)
    }
    
    const jobLink = `${process.env.REACT_APP_CAREER_JOB_URL}/${window.btoa(`id_${inputs.job_vacancy}`)}`;
    
    return (
        <Zoom>
            <Container sx={{ width: 'fit-content', height: '100%', display: 'flex', flexDirection: 'column', bgcolor: '#FFFFFF', p: '24px', borderRadius: '12px'}} className="overflowY">
                <Box position="relative" width='1080px' minHeight="1200px" height="100%"  display="flex" flexDirection="column" bgcolor="#F7F9F6" id="preview">
                    <Box component="img" src={inputs.bg_image.object === "" ? inputs.bg_image.value : inputs.bg_image.object} sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }}/>
                    <Box zIndex={1} flexGrow={1} display="flex" flexDirection="column" py="24px" gap="16px" onClick={handlerBg} sx={{ ':hover': { border: '3px solid #00ACC1', cursor: 'pointer' }, }}>
                        <Box display="flex" flexDirection="column" alignItems="center" gap="8px">
                            <label htmlFor='logo'>
                                <Avatar sx={{ width: 120, height: 120, cursor: 'pointer', ':hover': {border: '1px solid #00ACC1'}, img: { imageRendering: 'auto' } }} 
                                    src={inputs.company_logo.object === "" ? inputs.company_logo.value : inputs.company_logo.object} alt="company-logo" 
                                /> 
                            </label>
                            <input type='file' accept="image/*" id="logo" hidden name='company_logo' onChange={handlerChangeImage} />
                            <Typography fontSize="1.5rem" color={inputs.company_name_color} fontWeight={400} onClick={(e) => handlerCustomDesign(e,'company_name_color')}
                                 sx={{
                                    ...highlightCustom,
                                    width: '500px',
                                    textAlign: 'center',      
                                    alignSelf: 'center',         
                                    whiteSpace: 'normal',     
                                    wordBreak: 'break-word'
                                }}    
                            >
                                {inputs.company_name}
                            </Typography>
                            <Typography component="span" fontSize="2.188rem" fontWeight={700} color={inputs.tagline_color} onClick={(e) => handlerCustomDesign(e, 'tagline_color')}
                                // sx={{...highlightCustom,  letterSpacing: '-2%', lineHeight: '132%', wordBreak: 'normal', overflowWrap: 'break-word'}}
                                sx={{...highlightCustom,  width: '600px',
                                    textAlign: 'center',      
                                    alignSelf: 'center',         
                                    whiteSpace: 'normal',     
                                    wordBreak: 'break-word'}}

                                >
                                {inputs.tagline}
                            </Typography>
                            <Box fontSize="1.306rem" fontWeight="bold" width="350px" textAlign="center" py="8px" bgcolor="#137c35" color="#ffffff">
                                AVAILABLE JOB POSITION:
                            </Box>
                            <Typography fontSize="3.006rem" fontWeight={900} color={inputs.job_vacancy_color} onClick={(e) => handlerCustomDesign(e, 'job_vacancy_color')}
                                sx={{...highlightCustom,  width: '800px',
                                    textAlign: 'center',      
                                    alignSelf: 'center',         
                                    whiteSpace: 'normal',     
                                    wordBreak: 'break-word',
                                    textShadow: `3px 0px 0 ${inputs.job_vacancy_color}`,
                                }}
                            >
                                {
                                    inputs.with_job_acc && inputs.job_vacancy !== '' ?
                                        job.data.list.filter(f => f.job_id === inputs.job_vacancy)[0].name
                                    :
                                        inputs.job_vacancy
                                }
                            </Typography>
                        </Box>
                        <Grid container>
                            <Grid item lg={inputs.ft_image ? 7.5 : 12}>
                                <Typography p="4px 16px" fontSize="1.325rem" fontWeight={600} bgcolor={inputs.qualification_bg} borderRadius="4px" width="178px" 
                                    color={inputs.qualification_text_color} sx={{...highlightCustom, lineHeight: '147%', ':hover': { bgcolor: inputs.qualification_bg } }} onClick={(e) => handlerCustomDesign(e, 'qualification_text_color')}
                                >
                                    Qualifications:
                                </Typography>
                                <Box display="flex" flexDirection="column" gap="4px" pt="16px" pl="16px"
                                    color={inputs.qualification_list_color} sx={highlightCustom} onClick={(e) => handlerCustomDesign(e, 'qualification_list_color')}
                                >
                                    {
                                        (inputs.with_job_acc && inputs.job_vacancy ? job.data.qualification : inputs.qualification).map((v,k) => (
                                            <Box display="flex" alignItems="flex-start" gap="16px" key={k}>
                                                <KeyboardDoubleArrowRight
                                                    sx={{
                                                        fontSize: '2rem',
                                                        color: '#008acc', // blue fill
                                                        textShadow: `
                                                        -0.5px -0.5px 0 black,
                                                        0.5px -0.5px 0 black,
                                                        -0.5px 0.5px 0 black,
                                                        0.5px 0.5px 0 black
                                                        `,
                                                        marginBottom: 2
                                                    }}
                                                />
                                                <Typography fontSize="1.5rem" fontWeight={600} lineHeight="147%"
                                                    sx={{
                                                        wordBreak: 'break-word',
                                                        overflowWrap: 'break-word',
                                                        whiteSpace: 'normal'
                                                    }}
                                                >
                                                    {v.value}
                                                </Typography>
                                            </Box>
                                        ))
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    <Grid container bgcolor="#22a34b" minHeight={200} zIndex={1}>
                        <Grid item lg={4}>
                            <Box sx={{...highlightCustom, lineHeight: '147%', alignSelf: 'flex-start'}} onClick={(e) => handlerCustomDesign(e, 'location_color')} p="42px 0px 0px 14px">
                                <Typography fontSize="1.563rem" fontWeight="bold" color={inputs.location_color}>
                                    Work Location: 
                                </Typography>
                                <Typography fontSize="1.438rem" fontWeight="bold" color={inputs.location_color}
                                    sx={{wordWrap: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word'}}
                                >
                                    {inputs.work_location} 
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item lg={4} display="flex" justifyContent="center" alignItems="center">
                            {

                                inputs.with_job_acc &&
                                    <Box display="inline-block" alignItems="center" justifyContent="center" position="relative">
                                        <Box sx={{position: 'absolute', 
                                            top: '-12px',
                                            left: '50%', 
                                            transform: 'translateX(-50%)',
                                            backgroundColor: '#000',
                                            color: '#fff',
                                            px: 1.5,
                                            py: 0.5,
                                            borderRadius: '6px',
                                            fontSize: '10px',
                                            fontWeight: 700, 
                                            zIndex: 1
                                        }}
                                        >
                                            SCAN ME
                                        </Box>
                                        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" border="5px solid #000" p="3px" borderRadius="12px">
                                            <Box bgcolor="#fff" p="6px">
                                                <QRCodeSVG value={jobLink} size={150} level="H" />
                                            </Box>
                                        </Box>
                                    </Box>
                            }
                        </Grid>
                        <Grid item lg={4} display="flex" justifyContent="flex-end" alignItems="center"  sx={{ position: 'relative', zIndex: 10 }}>
                            {
                                inputs.violator && 
                                    <label htmlFor='violator_image'>
                                        <Box bgcolor="#fff" p="4px 0px 4px 4px" component="img" src={inputs.violator_image.object} alt="Vector-img" width="220px" height="80px" sx={{cursor: 'pointer', ':hover': {border: '1px solid #00ACC1'}, zIndex: 999 }} />
                                        <input type='file' accept="image/*" id="violator_image" hidden name='violator_image' onChange={handlerChangeImage} />
                                    </label>
                            }
                        </Grid>
                        <Grid item>
                            <Box position="absolute" right={0} bottom={0} zIndex={1}>
                                {
                                    inputs.ft_image &&
                                        <label htmlFor='ft_image'>
                                            <Avatar variant='rounded' sx={{ width: 392, height: 670,  cursor: 'pointer', ':hover': {border: '1px solid #00ACC1'} }} 
                                                src={inputs.ft_image.object === "" ? inputs.ft_image.value : inputs.ft_image.object} alt="ft_image" 
                                            /> 
                                            <input type="file" accept="image/*" id="ft_image" hidden name="ft_image" onChange={handlerChangeImage} />
                                        </label>
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Zoom>
    )
}

 
